import { InjectionToken } from '@angular/core';

export const OAUTH_URL = new InjectionToken<string>('OAUTH_URL');
export const OAUTH_CLIENT_ID = new InjectionToken<string>('OAUTH_CLIENT_ID');
export const EMBEDDED_PARENT_ORIGIN = new InjectionToken<string>('EMBEDDED_PARENT_ORIGIN');

/** 'redirect': start the OAuth redirect automatically when no token is available (default). 'on-demand': report `loginRequired` instead and wait for an explicit `login()`. */
export type B04LoginMode = 'redirect' | 'on-demand';
export const B04_LOGIN_MODE = new InjectionToken<B04LoginMode>('B04_LOGIN_MODE', {
  providedIn: 'root',
  factory: () => 'redirect',
});
